
export default function Industries() {
  const industries = [
    {
      title: 'Home Services',
      description: 'Streamlined scheduling, dispatch, and job management workflows with real-time operational visibility.',
      icon: 'ri-home-4-line'
    },
    {
      title: 'Med Spa',
      description: 'AI-assisted scheduling, intake, follow-ups, and front-office workflows designed for consistency and compliance.',
      icon: 'ri-heart-pulse-line'
    },
    {
      title: 'Real Estate',
      description: 'Transaction coordination, client workflows, and document processes designed for clarity and accountability.',
      icon: 'ri-building-line'
    },
    {
      title: 'Staffing & Recruiting',
      description: 'Unified candidate pipelines, task automation, and improved placement visibility without disrupting recruiters.',
      icon: 'ri-team-line'
    },
    {
      title: 'Payroll / HR / ERP',
      description: 'Standardized HR and payroll workflows designed to reduce errors, improve audit readiness, and scale reliably.',
      icon: 'ri-file-list-3-line'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Built for Service-Driven Organizations
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {industries.map((industry, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-xl border border-gray-200 hover:border-blue-200 hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${industry.icon} text-3xl text-blue-500 group-hover:scale-110 transition-transform`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {industry.title}
              </h3>
              
              <p className="text-sm text-gray-600 leading-relaxed">
                {industry.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
